import type { RouteRecordRaw } from 'vue-router';
import { isSchoolHost } from 'src/boot/authGuards';

function resolveImportedRoutes(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modules: Record<string, { [key: string]: any }>,
  exportName: string,
) {
  return Object.values(modules)
    .filter((module) => module[exportName])
    .flatMap((module) => module[exportName]);
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/BaseLayout/BaseLayout.vue'),
    children: [
      ...resolveImportedRoutes(
        import.meta.glob('../modules/*/routes.ts', { eager: true }),
        'base',
      ),
      {
        path: '',
        component: () =>
          import('../modules/User/pages/IndexPage/IndexPage.vue'),
        // The school domain has no marketing landing of its own — schools are sold
        // the product directly — so `/` there opens the school login instead of the
        // SET App index. Signed-in visitors are then moved on to their own home by
        // the auth guard, which already treats school.login as an entry route.
        beforeEnter: () =>
          isSchoolHost(
            window.location.hostname,
            import.meta.env.VITE_SCHOOL_HOSTS as string | undefined,
          )
            ? { name: 'school.login' }
            : true,
      },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout/MainLayout.vue'),
    children: [
      ...resolveImportedRoutes(
        import.meta.glob('../modules/*/routes.ts', { eager: true }),
        'main',
      ),
    ],
  },
  {
    path: '/school',
    component: () => import('layouts/SchoolLayout/SchoolLayout.vue'),
    children: [
      ...resolveImportedRoutes(
        import.meta.glob('../modules/*/routes.ts', { eager: true }),
        'school',
      ),
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

// if dev modde add the test page
if (import.meta.env.DEV) {
  routes?.[0]?.children!.push({
    path: '/test',
    component: () => import('pages/TestPage.vue'),
  });
}

console.log({ routes });
export default routes;
